import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import dayjs from 'dayjs';
import en_usJson from './locales/en_us/translations.json';
import pt_brJson from './locales/pt-BR/translations.json';
import es_arJson from './locales/es_ar/translations.json';

const storedLng = localStorage.getItem('language');
const lng = storedLng ?? 'en';

dayjs.locale(lng.replace('_', '-'));
i18n.use(LanguageDetector);
i18n.use(initReactI18next).init({
  fallbackLng: 'en_us',
  lng,
  resources: {
    en_us: {
      translations: en_usJson,
    },
    pt_br: {
      translations: pt_brJson,
    },
    es_ar: {
      translations: es_arJson,
    },
    fr: {
      translations: import('./locales/fr/translations.json'),
    },
    es: {
      translations: import('./locales/es/translations.json'),
    },
  },
  ns: ['translations'],
  defaultNS: 'translations',
});

export default i18n;
